import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { 
	TextField as MuiTextField, 
	IconButton, 
	InputAdornment 
} from '@mui/material';
import { Eye, EyeOff } from 'lucide-react';

const PasswordInput = ({
	control,
	name,
	placeholder = '',
	error,
}) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	return (
		<Controller
			control={control}
			name={name}
			render={({ field }) => (
				<MuiTextField
					{...field}
					type={showPassword ? 'text' : 'password'}
					placeholder={placeholder}
					fullWidth
					variant="outlined"
					error={!!error}
					helperText={error?.message}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
									edge="end"
								>
									{showPassword ? (
										<EyeOff size={20} color="#94a3b8" />
									) : (
										<Eye size={20} color="#94a3b8" />
									)}
								</IconButton>
							</InputAdornment>
						),
					}}
					sx={{
						'& .MuiOutlinedInput-root': {
							height: '48px',
							backgroundColor: '#ffffff',
							'& fieldset': {
								borderColor: '#e2e8f0',
							},
							'&:hover fieldset': {
								borderColor: '#cbd5e1',
							},
							'&.Mui-focused fieldset': {
								borderColor: '#0064b1',
							},
						},
						'& .MuiInputBase-input': {
							fontSize: '0.875rem',
							'&::placeholder': {
								color: '#94a3b8',
								opacity: 1,
							},
						},
					}}
				/>
			)}
		/>
	);
};

export default PasswordInput;
